module.exports = __webpack_public_path__ + "img/mgh-otemachi-sp@2x.9cc9ee22.jpg";